// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "route-2soUH";
var _4 = "passengers-2uLo5";
export { _1 as "__esModule", _2 as "mobile", _3 as "route", _4 as "passengers" }
export default { "__esModule": _1, "mobile": _2, "route": _3, "passengers": _4 }
